import angular from 'angular';
import constants from 'app/constants';
import product from './product';
import directive from './products.directive';
import controller from './products.controller';

export default angular.module('app.components.advisory.vendorManagement.products', [
  constants,
  product,
])
  .directive('vmProducts', directive)
  .controller('ProductsController', controller)
  .name;

console.log('app.components.advisory.vendorManagement.products created');
